export default __webpack_public_path__ + "static/media/customer.e5e5168d.png";